import React from "react";
import { Box, Tooltip } from "@mui/material";
import { useCustomer360 } from "components/customer360/Customer360Context";

const CustomerNameButton = ({ customerId, children }) => {
  const { openCustomer } = useCustomer360();

  if (customerId == null || customerId === "") {
    return children || null;
  }

  return (
    <Tooltip title="Visão 360º do cliente">
      <Box
        component="button"
        type="button"
        className="customer-name-button"
        onMouseDown={(event) => {
          if (event.ctrlKey || event.metaKey) {
            event.preventDefault();
          }
        }}
        onClick={(event) => {
          event.stopPropagation();
          const selection = window.getSelection();
          const selectedText = selection && !selection.isCollapsed ? selection.toString() : "";
          if (event.ctrlKey || event.metaKey || selectedText.trim()) {
            return;
          }
          openCustomer(customerId);
        }}
        sx={{
          border: 0,
          p: 0,
          m: 0,
          background: "transparent",
          color: "inherit",
          font: "inherit",
          lineHeight: "inherit",
          textAlign: "left",
          cursor: "pointer",
          "&:hover": {
            textDecoration: "underline",
          },
        }}
      >
        {children}
      </Box>
    </Tooltip>
  );
};

export default CustomerNameButton;
